import { createContext, useContext } from "react";

import {
	ProductDummyRoomFormModelContext,
	type ProductDummyRoomFormModelContextType,
} from "../../_shared/context/context";

export type ProductNewDummyRoomFormModelContextType = {
	onUpdate: () => void;
} & ProductDummyRoomFormModelContextType;

export const ProductNewDummyRoomFormModelContext = createContext<ProductNewDummyRoomFormModelContextType | null>(null);

export const ProductNewDummyRoomFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductNewDummyRoomFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductNewDummyRoomFormModelContext.Provider value={value}>
			<ProductDummyRoomFormModelContext.Provider value={value}>
				{children}
			</ProductDummyRoomFormModelContext.Provider>
		</ProductNewDummyRoomFormModelContext.Provider>
	);
};

export const useProductNewDummyRoomFormModelContext = () => {
	const context = useContext(ProductNewDummyRoomFormModelContext);

	if (!context) {
		throw new Error(
			"useProductNewDummyRoomFormModelContext must be used within a ProductNewDummyRoomFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
